import Script from "next/script";
import { EnergySavingCTA } from "./EnergySavingCTA/EnergySavingCTA";
import styles from "./EnergySaving.module.scss";
import { YourekoMedal } from "../../useYourekoEnergySaving";
import { useYourekoModal } from "./useYourekoModal";

const yourekoScriptUrl =
  "https://static.youreko.com/js/partners/gb/john-lewis/youreko.energy-review.john-lewis.no-hover-intent.all.min.js";

type Props = {
  energyCostSavingUnformatted: number;
  numberOfAlternatives: number;
  medalRatingText: YourekoMedal;
  refetch: () => void;
};

export const EnergySaving = ({
  energyCostSavingUnformatted,
  numberOfAlternatives,
  medalRatingText,
  refetch,
}: Props) => {
  const { proxyRef, shouldLoadScript, handleOpenModal, handleScriptLoad } =
    useYourekoModal(refetch);

  return (
    <>
      {shouldLoadScript && (
        <Script src={yourekoScriptUrl} onLoad={handleScriptLoad} />
      )}
      <div data-component="EnergySaving" className={styles.yourekoContainer}>
        <EnergySavingCTA
          onClick={handleOpenModal}
          energyCostSavingUnformatted={energyCostSavingUnformatted}
          medalRatingText={medalRatingText}
          numberOfAlternatives={numberOfAlternatives}
        />

        <div
          className={styles.yourekoHiddenProxyContainer}
          aria-hidden="true"
          ref={proxyRef}
        >
          <div className="youreko-energy-label" data-youreko-clicked={true} />
        </div>
      </div>
    </>
  );
};
